import React from 'react';

import Render from './Render';

import '../styles/index.scss';

class App extends React.Component {
	render() {
		return <Render {...window.social_link_pages} />;
	}
}

export default App;
